// eslint-disable-next-line @typescript-eslint/no-unused-vars, unused-imports/no-unused-imports-ts
import { Component, Fragment, Host, Prop, State, h } from '@stencil/core';

import { requiredParamsCheck } from '../../utils';
import { ComplianceConfig, defaultConfig, getComplianceConfig } from '../../utils/compliance';
import BlockedContentModal from '../functional/BlockedContentModal';

@Component({
    tag: 'bam-content-blocker',
    styleUrl: 'bam-content-blocker.css',
    shadow: true,
})
export class BamContentBlocker {
    /** If "true", the content will not be rendered at all IF blocked. Otherwise, the content will be blocked by a modal that will include the text/link of the returned compliance tag. */
    @Prop() hideIfBlocked = false;
    @Prop() defer = false;
    /** (required) */
    @Prop() location: string;
    /** (required) */
    @Prop() propertyId: number;
    /** (required) This is a comma-separated list of identifiers w/ NO SPACES, see below. This will determine the specified compliance identifiers to check. */
    @Prop() identifiers: string;

    /** Set the button text seen on the snippet, defaults to “Take Me There” (optional) */
    @Prop() buttonText: string;
    @Prop() devMode = false;

    @State() config: ComplianceConfig = defaultConfig;

    async connectedCallback() {
        if (!this.defer) {
            const hasMissingParams = requiredParamsCheck(
                {
                    property_id: this.propertyId,
                    identifiers: this.identifiers,
                },
                'Page Blocker'
            );

            if (hasMissingParams) {
                return;
            }

            this.config = await getComplianceConfig({
                propertyId: this.propertyId,
                identifiers: this.identifiers,
                location: this.location,
                devMode: this.devMode,
            });
        }
    }

    render() {
        return (
            <Host>
                {this.config.blocked ? (
                    <Fragment>
                        {this.hideIfBlocked ? null : (
                            <div class="container">
                                <BlockedContentModal buttonText={this.buttonText} config={this.config} />
                                <slot />
                            </div>
                        )}
                    </Fragment>
                ) : (
                    <slot />
                )}
            </Host>
        );
    }
}
